import config from 'gia/config';
import loadComponents from 'gia/loadComponents';

import Showroom from './showroom'
import Discover from './discover'
import Stack from './stack'
import Form from './form'
import Roll from './roll'
import Cover from './cover'
import Parallax from './parallax'
import lazySizes from 'lazysizes';
import Animation from './animation'



class App {

  constructor($) {
    this.create()
  }

  create() {

      lazySizes.init()
      // this.ease = bezier(.48,0,.12,1);
      // this.ease2 = bezier(.25,.46,.45,.94);
      config.set('log', false); // disables unnecessary console.log calls

      const components = {
        Animation: Animation,
        Showroom: Showroom,
        Stack: Stack,
        Form: Form,
        Cover: Cover,
        Parallax: Parallax,
        Discover: Discover,
        Roll: Roll,
      }

      loadComponents(components)


      $('#hamburger').on('click', (e)=>{
        e.preventDefault()
        $('body').toggleClass('has-menu')
      })

  }

    
}

module.exports = App
